import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function useSeo({ title, description, image }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    if (title) setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    if (image) setMeta("property", "og:image", image);
  }, [title, description, image]);
}
